// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { loadScript } from '../../../../support'

import { EmbedContent } from '../../Embed.contracts'

/**
 * Component capable of rendering the `EmbedModule`
 * with the version set to `EmbedVersion.Iframe`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component<EmbedTwitterUi>({
  name: 'EmbedIframeUi',
  mounted (): void {
    this.loadScript()
  },
  template: `
    <section>
      <div v-html="html" />
    </section>
  `
})
export class EmbedTwitterUi extends Vue {
  /**
   * Additional description of the embedded content.
   */
  @Prop({ type: String, required: false })
  public readonly description?: EmbedContent['description']

  /**
   * The `<iframe>` element to render.
   */
  @Prop({ type: String, required: true })
  private readonly twitter!: EmbedContent['twitter']

  /**
   * Protects you from accessing an undefined variable.
   *
   * @returns - `this.iframe` if it exists
   * @returns - Empty string, if this.iframe hasn't been defined or is broken.
   */
  public get html (): string {
    if (typeof this.twitter === 'string' && this.twitter.length > 0) {
      if (this.twitter.lastIndexOf('<script') < 0) {
        return this.twitter
      }

      return this.twitter.substr(0, this.twitter.lastIndexOf('<script'))
    }
    return ''
  }

  /**
   * Loads Twitter script.
   */
  private loadScript (): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }

    loadScript('https://platform.twitter.com/widgets.js')
      .then(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.$nextTick(() => window.twttr.widgets.load())
      })
      .catch(() => {
        console.warn('[EmbedTwitterUi] Failed to load Twitter script')
      })
  }
}
